// 🔧 auction_builder.js
// ✅ Purpose: Orchestrates Silent Auction demo data creation
// ✅ Features:
// - Generates auction items
// - Seeds auction data through repository layer
// - Updates DemoContext with auction results
// - Returns standardized Demo Report results
// - Fully block-commented for clarity and future devs

import { generateAuction } from "./auction_generator";
import { seedAuction } from "./auction_seeder";
import { buildAuctionReport } from "./auction_report";

export const buildAuction = async ({ demoContext } = {}) => {
  console.log("🔨 Auction Builder started.");

  const auctionPlan = generateAuction({ demoContext });

  const auctionResults = await seedAuction({
    demoContext,
    auctionPlan,
  });

  demoContext.auction = {
    items: auctionResults.items || [],
    bids: auctionResults.bids || [],
    allocations: auctionResults.allocations || [],
    orders: auctionResults.orders || [],
  };

  return buildAuctionReport({ auctionResults });
};
